import React from 'react';

function SoldOutIndicator() {
    return <span className="fam-warning-text grotesk-bold"> (Sold Out)</span>;
}

function SoldOutFacilitiesWarning({ facilityNames }) {
    if (!facilityNames?.length) {
        return null;
    }

    return <div className="fam-warning-text grotesk-regular">Sold out at: {facilityNames.join(', ')}</div>;
}

export { SoldOutFacilitiesWarning, SoldOutIndicator };
